import { Component, Input } from '@angular/core';
import { AVATAR_ANIMATIONS } from './avatar.animations';
import { CommonModule } from '@angular/common';
import { PictureComponent } from '../picture/picture.component';

@Component({
    selector: 'finder-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss'],
    animations: [...AVATAR_ANIMATIONS],
    standalone: true,
    imports: [
        CommonModule,
        PictureComponent
    ]
})
export class AvatarComponent {

    @Input() title: string;
    @Input() subtitle: string;
    @Input() detail: string;
    @Input() avatar: any;
    @Input() guest: any;
    @Input() animateAvatar = false;

    constructor() { }

}
